import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Empty, Pagination } from 'antd';
import { Actions, Container, NoData, Wrapper } from './style';
import { workConstructor } from './../../../utils/workConstructor';
import Spinner from '../../../components/Spinner';
import works from '../../../services/works';
import objectsService from '../../../services/objects';
import SecretarySentWorks from '../../../components/Cards/TaskCard';
import DatePicker from '../../../components/DatePicker';

export default () => {
  const { groupId, regionId } = useSelector((state) => state.authReducer);
  const { categories, regions, objects, groups, users } = useSelector(
    (state) => state.appReducer
  );
  const { singleDate } = useSelector((state) => state.selectedDateReducer);
  const provinceId = localStorage.getItem('provinceId');
  const [loading, setLoading] = useState(true);
  const [worksData, setWorksData] = useState([]);
  const [worksTotal, setWorksTotal] = useState(0);
  const [objectsList, setObjectsList] = useState([]);
  const [pageNum, setPageNum] = useState(1);
  const dispatch = useDispatch();
  const { constructorMethod } = workConstructor();

  const fetchWorks = () => {
    const common = { categories, regions, objects, groups, users };
    const postData = {
      date: singleDate,
      province: provinceId,
      region: regionId,
      group: groupId,
      page: pageNum,
      limit: 10,
      status: 2,
    };

    works
      .getSentWorksSecretary(postData)
      .then(({ docs, totalDocs }) => {
        const workerData = constructorMethod(docs, common);
        setWorksTotal(totalDocs);
        setWorksData(workerData);
      })
      .finally(() => setLoading(false))
      .catch((err) => console.error(err));
  };
  useEffect(() => {
    setLoading(true);
    fetchWorks();
  }, [singleDate, categories, regions, groups, users, pageNum]);
  useEffect(() => {
    if (worksData.length > 0) {
      const objId = categories?.find(
        (item) => item._id === worksData[0]?.subCategory
      )?.object;
      if (objId) {
        objectsService
          .getOne(objId)
          .then(() => {
            setObjectsList([]);
          })
          // .finally(() => setLoading(false))
          .catch((err) => console.error(err));
      }
    }
  }, [worksData]);

  if (loading) return <Spinner maxHeight='100%' />;
  return (
    <Wrapper>
      <Actions>
        <DatePicker />
      </Actions>
      {worksData.length > 0 ? (
        <Container>
          <div className='work'>
            {worksData.map((work, idx) => (
              <SecretarySentWorks key={idx} data={work} medium printTo />
            ))}
          </div>
          {worksTotal > 10 && (
            <div className='pagination-footer'>
              <Pagination
                current={pageNum}
                total={worksTotal}
                onChange={(page) => setPageNum(page)}
              />
            </div>
          )}
        </Container>
      ) : (
        <Container>
          <NoData>
            <Empty
              description={
                <h1>Белгиланган кун учун қилинган ишлар топилмади!</h1>
              }
            />
          </NoData>
        </Container>
      )}
    </Wrapper>
  );
};
